import * as Html from "../util/Html.ts";
import * as FwDatas from "../FwDatas.ts";
import * as modal from "../util/modal.ts";
import Icons from "../svg/Icons.ts";
import ApiServer from "../ApiServer.js";

export {init}
Html.registerWidget('contact/widget-note-updater',{init:init})


function init(obj){
  
  obj.on('change',function(){
    var 
      contact = FwDatas.get( obj.metaId());
    
    contact.note = this.value;
    ApiServer.ctcput(contact,function(){
      modal.toast({svg:Icons.ic_done,text:"contact.notesaved"})
    })
  });
}